import { BaseApiClient } from './client'
import { MembersApi } from './modules/members'
import { CampaignsApi } from './modules/campaigns'
import { ReferralsApi } from './modules/referrals'
import { SettingsApi } from './modules/settings'
import { DashboardApi } from './modules/dashboard'
import { BackofficeApi } from './modules/backoffice'
import { DevApi } from './modules/dev'
import { WebhooksApi } from './modules/webhooks'
import { AnalyticsApi } from './modules/analytics'
import { CreatorsApi } from './modules/creators'
import { CreatorProgramsApi } from './modules/creator-programs'
import { CommissionTiersApi } from './modules/commission-tiers'
import { CreatorPayoutsApi } from './modules/creator-payouts'
import { SeedingsApi } from './modules/seedings'
import { CreatorPostsApi } from './modules/creator-posts'
import { PublicCreatorApi } from './modules/public-creator'
import { SocialListeningApi } from './modules/social-listening'
import { CreatorNotesApi } from './modules/creator-notes'
import { NotificationsApi } from './modules/notifications'

export * from './types'

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

class ApiClient extends BaseApiClient {
  members: MembersApi
  campaigns: CampaignsApi
  referrals: ReferralsApi
  settings: SettingsApi
  dashboard: DashboardApi
  backoffice: BackofficeApi
  dev: DevApi
  webhooks: WebhooksApi
  analytics: AnalyticsApi
  public creators: CreatorsApi
  public creatorPrograms: CreatorProgramsApi
  public commissionTiers: CommissionTiersApi
  public creatorPayouts: CreatorPayoutsApi
  public seedings: SeedingsApi
  public creatorPosts: CreatorPostsApi
  public publicCreator: PublicCreatorApi
  public socialListening: SocialListeningApi
  public creatorNotes: CreatorNotesApi
  public notifications: NotificationsApi

  constructor(baseUrl: string) {
    super(baseUrl)
    this.members = new MembersApi(baseUrl)
    this.campaigns = new CampaignsApi(baseUrl)
    this.referrals = new ReferralsApi(baseUrl)
    this.settings = new SettingsApi(baseUrl)
    this.dashboard = new DashboardApi(baseUrl)
    this.backoffice = new BackofficeApi(baseUrl)
    this.dev = new DevApi(baseUrl)
    this.webhooks = new WebhooksApi(baseUrl)
    this.analytics = new AnalyticsApi(baseUrl)
    this.creators = new CreatorsApi(baseUrl)
    this.creatorPrograms = new CreatorProgramsApi(baseUrl)
    this.commissionTiers = new CommissionTiersApi(baseUrl)
    this.creatorPayouts = new CreatorPayoutsApi(baseUrl)
    this.seedings = new SeedingsApi(baseUrl)
    this.creatorPosts = new CreatorPostsApi(baseUrl)
    this.publicCreator = new PublicCreatorApi(baseUrl)
    this.socialListening = new SocialListeningApi(baseUrl)
    this.creatorNotes = new CreatorNotesApi(baseUrl)
    this.notifications = new NotificationsApi(baseUrl)
  }
}

export const api = new ApiClient(API_BASE_URL)
